import { Card, CardContent } from '@/components/card/card'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'
import { Tabs, TabsList, TabsTrigger } from '@/components/tabs/tabs'

import { cn } from '@/lib/utils'

import { SubscriptionOverlay } from '../../../subscription-overlay/subscription-overlay'
import { TIMEFRAME_OPTIONS } from './constants'
import { mockVisaBulletinMonthlySeries, mockVisaBulletinTrendData } from './mock'
import { useVisaBulletinTrendDialog } from './use-visa-bulletin-trend-dialog'
import { VisaBulletinTrendChart } from './visa-bulletin-trend-chart'
import { VisaBulletinTrendTable } from './visa-bulletin-trend-table'

export const VisaBulletinTrendDialog = () => {
  const {
    dataUser,
    dataVisaBulletinTrend,
    visaBulletinMonthlySeries,
    timeFrame,
    priorityDate,
    isDialogOpen,
    handleTimeFrameChange,
    handleChangeDialogOpen,
  } = useVisaBulletinTrendDialog()

  return (
    <Dialog open={isDialogOpen} onOpenChange={handleChangeDialogOpen}>
      <DialogContent className={cn('max-w-[780px]', 'overflow-visible', 'bg-zinc-50')}>
        <DialogHeader className={cn('mb-3')}>
          <DialogTitle>Visa Bulletin Trends</DialogTitle>
          <DialogDescription className="sr-only">
            Interactive chart displaying USCIS visa bulletin trends over time.
          </DialogDescription>
        </DialogHeader>

        <div className={cn('relative')}>
          <Tabs value={timeFrame} onValueChange={handleTimeFrameChange}>
            <TabsList>
              {TIMEFRAME_OPTIONS.map(({ value, label }) => {
                return (
                  <TabsTrigger key={value} value={String(value)}>
                    {label}
                  </TabsTrigger>
                )
              })}
            </TabsList>
          </Tabs>

          <Card>
            <CardContent className={cn('pb-4.5 pl-9 pr-0 pt-9')}>
              {visaBulletinMonthlySeries && (
                <VisaBulletinTrendChart
                  monthlySeries={dataUser?.hasSubscription ? visaBulletinMonthlySeries : mockVisaBulletinMonthlySeries}
                  priorityDate={dataUser?.hasSubscription ? priorityDate : '2014-01-01'}
                />
              )}
            </CardContent>
          </Card>

          {!!dataVisaBulletinTrend && (
            <VisaBulletinTrendTable
              className={cn('mt-3')}
              data={dataUser?.hasSubscription ? dataVisaBulletinTrend : mockVisaBulletinTrendData}
            />
          )}

          {!dataUser?.hasSubscription && (
            <SubscriptionOverlay isAdmin={dataUser?.isAdmin} isFreeTrialAvailable={dataUser?.isFreeTrialAvailable} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
